import { useNavigate, useLocation } from 'react-router-dom';
import { PlaylistForm } from '@/components/playlists/PlaylistForm';

export default function NewPlaylist() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAi = Boolean((location.state as { isAi?: boolean } | null)?.isAi);

  const handleSuccess = () => {
    navigate('/playlists');
  };

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="space-y-1">
        <h2 className="text-2xl font-semibold tracking-tight">
          {isAi ? 'Yeni AI Playlist Oluştur' : 'Yeni Playlist Oluştur'}
        </h2>
        <p className="text-sm text-muted-foreground">
          {isAi
            ? 'AI üretilmiş şarkılardan oluşan bu playlist "AI" etiketiyle kaydedilecek'
            : 'Seçili şarkılardan yeni bir playlist oluşturun'}
        </p>
      </div>

      <PlaylistForm onSuccess={handleSuccess} isAi={isAi} />
    </div>
  );
}
